import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { Link } from 'react-router-dom'
import { ChevronLeft as ChevronLeftIcon } from 'react-feather'
// import TextField from '@material-ui/core/TextField'
import { makeStyles } from '@material-ui/core'
import { useFormInput } from 'src/hooks'
import Select from '@material-ui/core/Select'
// import MenuItem from '@material-ui/core/MenuItem'
// import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
// import AgeCategory from '../../constants/ageCategory'
import { addNotification, selectorAgeCategories, getAllAgeCategories } from '../../app/slices/notificationSlice'
import { CssTextField, CssFormControl, StyledMenuItem } from '../../utils/CustomInputs'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}

const useStyle = makeStyles(() => ({
  root: {
    borderRadius: '20px',
  },
  topRow: {
    marginBottom: '2rem',
  },
  textarea: {
    width: '100%',
  },
  formInputs: {
    marginBottom: '1rem',
  },
}))

export const NotificationForm = () => {
  const classes = useStyle()
  const title = useFormInput()
  const content = useFormInput()
  const ageCategories = useSelector(selectorAgeCategories)
  const priority = useFormInput()
  const ageCategory = useFormInput([])
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getAllAgeCategories())
  }, [])

  const handelSubmit = (event) => {
    event.preventDefault()
    dispatch(addNotification({
      content: content.value,
      title: title.value,
      priority: parseInt(priority.value, 10),
      ageCategoryIds: ageCategory?.value?.length ? ageCategory?.value?.split(',') : [ageCategory?.value],
    }))
  }

  const allAgeCategories = [{
    ageCategoryId: ageCategories?.map((item) => item?.ageCategoryId).toString(),
    description: 'all',
    fromYear: 0,
    name: 'همه رده های سنی',
    toYear: 100,
  },
  ...ageCategories]

  return (
    <form onSubmit={handelSubmit}>
      <Card
        className={classes.root}
      >
        <CardContent>
          <Grid className={classes.topRow} container justify="space-between">
            <Typography variant="h3" component="h3">اعلانیه جدید</Typography>
            <Link to="../">
              <Button color="primary">
                <span>بازگشت</span>
                <ChevronLeftIcon />
              </Button>
            </Link>
          </Grid>
          <Grid className={classes.formInputs} container spacing={2}>
            <Grid item xs={12} md={4}>
              <CssTextField required fullWidth {...title} label="عنوان" variant="outlined" />
            </Grid>
            <Grid item xs={12} md={4}>
              <CssTextField required fullWidth {...priority} type="number" label="اولویت" variant="outlined" />
            </Grid>
            <Grid item varia xs={12} md={4}>
              <CssFormControl variant="outlined" fullWidth>
                <InputLabel id="demo-mutiple-name-label">رده سنی</InputLabel>
                <Select
                  required
                  labelId="demo-mutiple-name-label"
                  id="demo-mutiple-name"
                  // multiple
                  {...ageCategory}
                  MenuProps={MenuProps}
                >
                  {allAgeCategories?.map((category, i) => (
                    <StyledMenuItem
                      key={i}
                      value={category?.ageCategoryId}
                    >
                      {category?.name}
                    </StyledMenuItem>
                  ))}
                </Select>
              </CssFormControl>
            </Grid>
            <Grid item xs={12}>
              <CssTextField
                className={classes.textarea}
                label="متن"
                {...content}
                multiline
                rows={4}
                required
                defaultValue=""
                variant="outlined"
              />
            </Grid>
            <Grid item container justify="flex-end">
              <Button variant="contained" color="primary" type="submit">ارسال</Button>
            </Grid>
          </Grid>

        </CardContent>
      </Card>
    </form>
  )
}

export default NotificationForm
